import TableMui from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { PAGE_INITIAL_VALUE, ROWS_PER_PAGE_OPTION } from 'common/constants';
import { useState } from 'react';
import { Fragment } from 'react/jsx-runtime';
import { formatGroups } from 'utils/formatters';
import { useStoreSelector } from 'v3/data/store';
import { setFilterCurrentPage, setFilterRowsPerPage, setGroupAdminSelected } from 'v3/data/store/groupAdmin/actions';
import { IGroupAdminItem } from 'v3/data/store/groupAdmin/types';
import { useBreakpoints } from 'v3/hooks/useBreakpoints';
import { AlignStatusContainer } from 'v3/shared/components/MobileTable/CreateGroupMobileTable/styles';
import { GroupAdminMobileTable } from 'v3/shared/components/MobileTable/GroupAdminMobileTable';
import { EditIcon } from 'v3/shared/components/MobileTable/styles';
import { GroupAdminModal } from 'v3/shared/components/Modal/GroupAdminModal';
import { IModal, Mode } from 'v3/shared/components/Modal/GroupAdminModal/types';
import { NoItemsFound } from 'v3/shared/components/NoItemsFound';
import { SubtitleMedium } from 'v3/shared/typography/SubtitleMedium';
import { BoxCustom, PaperStyled, TableMobilePaginationStyles, TablePaginationStyles, TableRowStyled } from '../styles';
import { TableCellGroup, TableCellStyled } from './styles';

export const GroupsAdminTable = ({ groupsAdminList }) => {
  const { isMobile } = useBreakpoints();
  const { filter, list, allGroups, groups } = useStoreSelector((store) => store.groupAdmin);

  const { page, rowsPerPage } = filter;
  const { count } = list;

  const [groupAdminModal, setGroupAdminModal] = useState<IModal>({
    active: false,
    cancelButton: 'Cancelar',
    saveButton: 'Salvar',
    title: 'Editar grupo admin',
    mode: Mode.Edit,
  });

  const handleOpenModal = (groupAdmin: IGroupAdminItem) => {
    setGroupAdminSelected(groupAdmin);
    setGroupAdminModal({ ...groupAdminModal, active: true });
  };

  return (
    <Fragment>
      {list.items.length === 0 ? (
        <NoItemsFound />
      ) : !isMobile ? (
        <BoxCustom>
          <PaperStyled>
            <TableContainer sx={{ maxHeight: 450 }}>
              <TableMui stickyHeader aria-label="sticky tables">
                <TableHead>
                  <TableRow>
                    <TableCellStyled>Nome</TableCellStyled>
                    <TableCellStyled>E-mail</TableCellStyled>
                    <TableCellStyled>Grupo</TableCellStyled>
                    <TableCellStyled>Ações</TableCellStyled>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {list.items.map((item, index) => {
                    return (
                      <TableRowStyled hover key={index}>
                        <TableCellGroup key={`name-${index}`}>
                          <SubtitleMedium>{item.name}</SubtitleMedium>
                        </TableCellGroup>

                        <TableCellGroup key={`email-${index}`}>
                          <SubtitleMedium>{item.email}</SubtitleMedium>
                        </TableCellGroup>

                        <TableCellGroup key={`group-${index}`}>
                          <SubtitleMedium>{formatGroups(item.groupAdmin)}</SubtitleMedium>
                        </TableCellGroup>

                        <TableCellGroup key={`actions-${index}`}>
                          <AlignStatusContainer>
                            <SubtitleMedium>Editar</SubtitleMedium>
                            <EditIcon onClick={() => handleOpenModal(item)} />
                          </AlignStatusContainer>
                        </TableCellGroup>
                      </TableRowStyled>
                    );
                  })}
                </TableBody>
              </TableMui>
            </TableContainer>
          </PaperStyled>
          <TablePagination
            rowsPerPageOptions={ROWS_PER_PAGE_OPTION}
            component="div"
            sx={TablePaginationStyles}
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(event, value) => setFilterCurrentPage(value)}
            onRowsPerPageChange={(event) => {
              setFilterCurrentPage(PAGE_INITIAL_VALUE);
              setFilterRowsPerPage(Number(event.target.value));
            }}
          />
        </BoxCustom>
      ) : (
        <Fragment>
          <GroupAdminMobileTable groupsAdminList={groupsAdminList} />
          <TablePagination
            rowsPerPageOptions={ROWS_PER_PAGE_OPTION}
            component="div"
            sx={TableMobilePaginationStyles}
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            labelRowsPerPage="Cards por página:"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            onPageChange={(event, value) => setFilterCurrentPage(value)}
            onRowsPerPageChange={(event) => {
              setFilterCurrentPage(PAGE_INITIAL_VALUE);
              setFilterRowsPerPage(Number(event.target.value));
            }}
          />
        </Fragment>
      )}

      <GroupAdminModal
        modal={groupAdminModal}
        fullStoreGrouplist={allGroups}
        adminStoreGroupList={groups}
        onClose={() => setGroupAdminModal({ ...groupAdminModal, active: false })}
        onConfirm={(data, reset) => setGroupAdminModal({ ...groupAdminModal, active: false })}
      ></GroupAdminModal>
    </Fragment>
  );
};
